import * as types from "./types";
import assets from "../util/assets";
import PropTypes from "prop-types";

export const showRequestAvailableBroadcasterModal = () => ({
  type: types.SHOW_REQUEST_AVAILABLE_BROADCAST_MODAL,
});

export const hideRequestAvailableBroadcasterModal = () => ({
  type: types.HIDE_REQUEST_AVAILABLE_BROADCAST_MODAL,
});

export const showAwaitingAvailableBroadcasterModal = () => ({
  type: types.SHOW_AWAITING_MODAL,
});

export const hideAwaitingAvailableBroadcasterModal = () => ({
  type: types.HIDE_AWAITING_MODAL,
});

export const showCommonConfirmationModal = () => ({
  type: types.SHOW_COMMON_CONFIRMATION_MODAL,
});

export const hideCommonConfirmationModal = () => ({
  type: types.HIDE_COMMON_CONFIRMATION_MODAL,
});

// Tip modal from user side
export const showTipModal = () => ({
  type: types.SHOW_TIP_MODAL,
});

export const hideTipModal = () => {

  return {
    type: types.HIDE_TIP_MODAL,
  };
};

export const showTipResponseModal = () => ({
  type: types.SHOW_TIP_RESPONSE_MODAL,
});

export const hideTipResponseModal = () => {
  return {
    type: types.HIDE_TIP_RESPONSE_MODAL,
  };
};

// Tip modal from broadcaster side
export const showTipListModal = () => ({
  type: types.SHOW_TIP_LIST_MODAL,
});

export const hideTipListModal = () => {
  return {
    type: types.HIDE_TIP_LIST_MODAL,
  };
};

export const showCommonModal = (payload, isConfirmationModal = false, actionArray = []) => ({
  type: types.SHOW_COMMON_MODAL,
  payload: payload,
  isConfirmationModal: isConfirmationModal,
  actionArray: actionArray,
});

export const hideCommonModal = () => ({
  type: types.HIDE_COMMON_MODAL,
  payload: {
    image: assets.awaiting_stopwatch,
    title: "Title",
    description: "Description",
    action: {
      text: "OK",
      click: () => {
        console.log("Clicked on OK")
      }
    }
  },
});

export const showBroadcasterVideoPlayerModal = (payload) => ({
  type: types.SHOW_BROADCASTER_VIDEO_PLAYER_MODAL,
  payload:payload
});

export const hideBroadcasterVideoPlayerModal = () => ({
  type: types.HIDE_BROADCASTER_VIDEO_PLAYER_MODAL,
  payload: {
    video: null,
    action: {
      text: "OK",
      click: () => {
        console.log("Clicked on OK")
      }
    }
  },
});